import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Grid, TextField, FormControl,
  InputLabel, Select, MenuItem } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { es } from 'date-fns/locale';
import AppBarModal from '../../../general/AppBarModal';
import TareasTerminadas from '../../../general/TareasTerminadas';
import { BtnForm } from '../../../general/BotonesAccion';
import emma_w from '../../../../global/imagenes/emma_w.png';
import { consulta, obtenerValores } from '../../../../global/js/funciones';
import { PAISES, ESTADOS_CONVENIOS } from '../helper';
import { COLUMNAS, OPCIONES_RENOVACION, validarFilas } from './excelConvenios';

// Mismos campos y misma validacion que el Excel (validarFilas). Vive aparte porque
// se abre desde dos sitios: Convenios Registrados y el boton Editar de Administrar.

const ROJO = '#900807';

// El formulario guarda DD/MM/AAAA; el datepicker trabaja con Date.
const aFecha = (texto) => {
  let m = String(texto || '').match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return null;
  let d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  return isNaN(d.getTime()) ? null : d;
};

const aTextoFecha = (d) => (
  `${('0' + d.getDate()).slice(-2)}/${('0' + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`
);

const vacio = () => COLUMNAS.reduce((acc, { clave }) => Object.assign(acc, { [clave]: '' }), {});

class ConvenioRegistradoEditar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: vacio(),
      fechas: { FECHA_INICIO: null, FECHA_FINALIZACION: null },
      paises: [],
      estados: [],
      guardando: false,
      errores: '',
    };
  }

  async componentDidMount() {
    let { paises, estados } = this.props;
    if ((paises && paises.length) && (estados && estados.length)) {
      this.setState({ paises, estados });
    } else {
      let [p, e] = await Promise.all([obtenerValores(PAISES), obtenerValores(ESTADOS_CONVENIOS)]);
      this.setState({
        paises: (p || []).map(({ nombre }) => nombre).filter(Boolean).sort(),
        estados: (e || []).map(({ nombre }) => nombre).filter(Boolean),
      });
    }
    this.cargarConvenio();
  }

  componentDidUpdate({ convenio }) {
    let actual = this.props.convenio;
    let mismo = (convenio && actual && convenio.id === actual.id) || (!convenio && !actual);
    if (!mismo) this.cargarConvenio();
  }

  cargarConvenio() {
    let { convenio } = this.props;
    if (!convenio) return;
    let form = vacio();
    COLUMNAS.forEach(({ clave }) => {
      form[clave] = convenio[clave] === null || convenio[clave] === undefined ? '' : String(convenio[clave]);
    });
    this.setState({
      form,
      fechas: { FECHA_INICIO: aFecha(form.FECHA_INICIO), FECHA_FINALIZACION: aFecha(form.FECHA_FINALIZACION) },
      errores: '',
    });
  }

  onChange = ({ target }) => {
    let { name, value } = target;
    this.setState({ form: Object.assign({}, this.state.form, { [name]: value }), errores: '' });
  }

  // Mientras se escribe la fecha aun no es valida: se guarda el texto para que la
  // validacion lo señale en vez de descartarlo en silencio.
  cambiarFecha = (clave, fecha, texto) => {
    let valida = fecha instanceof Date && !isNaN(fecha.getTime());
    this.setState({
      fechas: Object.assign({}, this.state.fechas, { [clave]: fecha }),
      form: Object.assign({}, this.state.form, { [clave]: valida ? aTextoFecha(fecha) : String(texto || '').trim() }),
      errores: '',
    });
  }

  guardar = () => {
    let { convenio, codigosExistentes, onGuardado, actualizarMensaje } = this.props;
    let { form, paises } = this.state;

    // El propio codigo se excluye del control de duplicados.
    let otros = (codigosExistentes || []).filter((c) => c && c !== convenio.CODIGO);
    let revisada = validarFilas([Object.assign({}, form, { n: 0 })], otros, paises)[0];
    if (revisada.error) {
      this.setState({ errores: revisada.error });
      return;
    }

    this.setState({ guardando: true });
    consulta(`api/v1.0/internacionalizacion/convenios/${convenio.id}/modificar_registrado`, form, 'put',
      (error, estado, resp) => {
        if (error || estado !== 200) {
          this.setState({
            guardando: false,
            errores: resp && resp.titulo ? resp.titulo : 'Ha ocurrido un error, contacte con el administrador.',
          });
          return;
        }
        this.setState({ guardando: false });
        if (actualizarMensaje) {
          actualizarMensaje({ titulo: resp.titulo, tipo: 'success', mostrar: true, tiempo: 4000 });
        }
        onGuardado(resp.convenio);
      });
  }

  campoTexto(clave, etiqueta, extra = {}) {
    return (
      <Grid item xs={12} sm={extra.ancho || 6}>
        <TextField
          fullWidth
          id={clave}
          name={clave}
          label={etiqueta}
          value={this.state.form[clave]}
          onChange={this.onChange}
          type={extra.type || 'text'}
          multiline={!!extra.multiline}
          required={!!extra.required}
        />
      </Grid>
    );
  }

  campoLista(clave, etiqueta, opciones) {
    return (
      <Grid item xs={12} sm={6}>
        <FormControl className='form-control' fullWidth>
          <InputLabel htmlFor={clave}>{etiqueta}</InputLabel>
          <Select inputProps={{ name: clave, id: clave }} value={this.state.form[clave]} onChange={this.onChange}>
            <MenuItem value=''><em>Sin definir</em></MenuItem>
            {opciones.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
          </Select>
        </FormControl>
      </Grid>
    );
  }

  campoFecha(clave, etiqueta) {
    return (
      <Grid item xs={12} sm={6}>
        <KeyboardDatePicker
          id={clave}
          name={clave}
          label={etiqueta}
          format='dd/MM/yyyy'
          value={this.state.fechas[clave]}
          onChange={(fecha, texto) => this.cambiarFecha(clave, fecha, texto)}
          style={{ width: '100%', marginTop: 0 }}
          clearable
          clearLabel='Borrar'
          cancelLabel='Cancelar'
          okLabel='Aceptar'
          todayLabel='Hoy'
          invalidDateMessage='Formato de fecha no válido (DD/MM/AAAA).'
          KeyboardButtonProps={{ 'aria-label': etiqueta }}
        />
      </Grid>
    );
  }

  render() {
    let { abierto, cerrar } = this.props;
    let { guardando, errores, paises, estados } = this.state;
    return (
      <Dialog open={!!abierto} onClose={cerrar} fullWidth maxWidth='md'>
        <AppBarModal titulo='¡ Editar convenio !' mostrarModal={cerrar} titulo_accion='' accion='' />
        <DialogContent className='scroll'>
          {
            guardando
              ? <TareasTerminadas mensaje='Guardando cambios..' marginTop='7%' imagen={emma_w} widthImg='7%' />
              : <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
                <Grid container spacing={3} style={{ marginTop: '4px' }}>
                  {this.campoTexto('CODIGO', 'Código', { required: true })}
                  {this.campoTexto('INSTITUCION', 'Institución', { required: true })}
                  {this.campoLista('PAIS', 'País', paises)}
                  {this.campoTexto('PROGRAMA_COORDINADOR', 'Programa / Coordinador')}
                  {this.campoFecha('FECHA_INICIO', 'Fecha de inicio')}
                  {this.campoFecha('FECHA_FINALIZACION', 'Fecha de finalización')}
                  {this.campoTexto('VIGENCIA', 'Vigencia (años)', { type: 'number' })}
                  {this.campoLista('RENOVACION', 'Renovación', OPCIONES_RENOVACION)}
                  {this.campoLista('ESTADO', 'Estado del convenio', estados)}
                  {this.campoTexto('SEGUIMIENTO', 'Seguimiento renovaciones / terminaciones', { multiline: true, ancho: 12 })}
                  {this.campoTexto('OBSERVACION', 'Observación', { multiline: true, ancho: 12 })}
                  {
                    errores &&
                    <Grid item xs={12}>
                      <div style={{ border: `1px solid ${ROJO}`, borderLeft: `5px solid ${ROJO}`, padding: '10px 14px', color: ROJO, fontSize: '13px' }}>
                        {errores}
                      </div>
                    </Grid>
                  }
                </Grid>
              </MuiPickersUtilsProvider>
          }
        </DialogContent>
        <DialogActions>
          <BtnForm texto='CANCELAR' callback={cerrar} />
          <BtnForm texto='GUARDAR' callback={this.guardar} />
        </DialogActions>
      </Dialog>
    );
  }
}

ConvenioRegistradoEditar.propTypes = {
  abierto: PropTypes.bool.isRequired,
  cerrar: PropTypes.func.isRequired,
  onGuardado: PropTypes.func.isRequired,
  // Con las claves de la plantilla, como lo devuelve convenios/registrados.
  convenio: PropTypes.object,
  codigosExistentes: PropTypes.array,
  paises: PropTypes.array,
  estados: PropTypes.array,
  actualizarMensaje: PropTypes.func,
};

export default ConvenioRegistradoEditar;
